<template>
     <div class="role position-relative">
          <div class="title"></div>
          <!-- 实际展示区域 -->
          <div class="box ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="0.3s" swiper-animate-delay="0.1s">
               <swiper :options="silderOption" ref="silderSwiper">
                    <swiper-slide v-for="(n, index) in list" :key="index">
                         <div class=" position-relative roleInfo">
                              <img :src="n.roleInfo" alt="" srcset="" />
                         </div>
                    </swiper-slide>
                    <div class="
            swiper-pagination swiper-pagination-role
            cursor
            position-absolute
          " slot="pagination"></div>
               </swiper>
          </div>
     </div>
</template>
<script>
export default {
     data() {
          return {
               silderOption: {
                    autoplay: {
                         disableOnInteraction: false,
                         delay: 10000,
                    },
                    loop: true,
                    direction: "horizontal",
                    // effect: "fade",
                    effect: "fade",
                    fadeEffect: {
                         crossFade: true,
                    },
                    observer: true, //修改swiper自己或子元素时，自动初始化swiper
                    observeParents: true, //修改swiper的父元素时，自动初始化swiper
                    pagination: {
                         el: ".swiper-pagination-role",
                         touchRatio: 1, //解决滑动卡顿
                         longSwipesRatio: 0.1,
                         threshold: 10, //如果触摸距离小于该值滑块不会被拖动
                         followFinger: false,
                         bulletClass: "my-bullet", //需设置.my-bullet样式
                         clickable: true, // 允许点击小圆点跳转
                         renderBullet: function (index, className) {
                              switch (index) {
                                   case 0:
                                        name = "";
                                        break;
                                   case 1:
                                        name = "";
                                        break;
                                   case 2:
                                        name = "";
                                   case 3:
                                        name = "";
                                   default:
                                        name = "";
                              }
                              return (
                                   '<div class="' +
                                   className +
                                   " " +
                                   className +
                                   [index] +
                                   '"><i>' +
                                   name +
                                   "</i></div>"
                              );
                         },
                    },
               },
               list: [
                    {
                         id: 1,
                         title: require("../../assets/img/role/character_1/title.png"),
                         roleInfo: require("../../assets/img/role/character_1/roleInfo.png"),


                    },

                    {
                         id: 2,
                         title: require("../../assets/img/role/character_2/title.png"),
                         roleInfo: require("../../assets/img/role/character_2/roleInfo.png"),


                    },
                    {
                         id: 3,
                         title: require("../../assets/img/role/character_3/title.png"),
                         roleInfo: require("../../assets/img/role/character_3/roleInfo.png"),


                    },
                    {
                         id: 4,
                         title: require("../../assets/img/role/character_4/title.png"),
                         roleInfo: require("../../assets/img/role/character_4/roleInfo.png"),

                    },
               ],
          }
     }
}
</script>
<style lang='scss' >
.role {
     height: 1500px;
     width: 100%;

     .title {
          background: url("../../assets/img/role/title.png") no-repeat center top;
          background-size: 100% 100%;
          width: 793px;
          height: 161px;
          margin: 0 auto;
     }

     .box {
          position: absolute;
          z-index: 999;
          width: 1400px;
          height: 100%;
          left: 300px;
          padding-top: 80px;

          .roleInfo {
               img {
                    display: block;
                    width: 1200px;
                    height: 940px;
               }
          }
     }

     // 角色轮播图分页圆点更改背景
     .swiper-pagination-role {
          right: 0 !important;
          left: auto !important;
          width: 323px !important;
          height: 682px;
          top: 0;

          .swiper-pagination-bullet-active {
               background: transparent;
          }

          .my-bullet {
               position: absolute;
               i {
                    display: block;
                    width: 152px;
                    height: 163px;
               }
          }

          // 未选中
          .my-bullet0 {
               
               top: 60px;
               left: -60px;
               i {
                    background: url("../../assets/img/role/btn1.png") center top;
                    background-size: 100% 100%;
               }
          }

          .my-bullet1 {
               top: 210px;
               left: 15px;
               i {
               background: url("../../assets/img/role/btn2.png") center top;
               background-size: 100% 100%;
          }
          }

          .my-bullet2 {
               top: 380px;
               left: 60px;
               i {
               background: url("../../assets/img/role/btn3.png") center top;
               background-size: 100% 100%;
          }

          }
          .my-bullet3{
               top: 560px;
               left: 85px;
               i {
               background: url("../../assets/img/role/btn4.png") center top;
               background-size: 100% 100%;
          }
          }

          //     // 选中后的按钮图
          .my-bullet0.swiper-pagination-bullet-active i {
               background: url("../../assets/img/role/btn1-active.png") center top;
               background-size: 100% 100%;
          }

          .my-bullet1.swiper-pagination-bullet-active i {
               background: url("../../assets/img/role/btn2-active.png") center top;
               background-size: 100% 100%;
          }

          .my-bullet2.swiper-pagination-bullet-active i {
               background: url("../../assets/img/role/btn3-active.png") center top;
               background-size: 100% 100%;
          }

          .my-bullet3.swiper-pagination-bullet-active i {
               background: url("../../assets/img/role/btn4-active.png") center top;
               background-size: 100% 100%;
          }
     }
}
</style>


// WEBPACK FOOTER //
// src/components/mainComponents/rolePage.vue